import React from 'react';
import Icon from '@mdi/react';
import { mdiClose, mdiRefresh } from '@mdi/js';
import styles from './chatHeader.module.scss';
import { images } from '../../../../constants/images';

interface ChatHeaderProps {
    onClose: () => void;
    onRefresh?: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ onClose, onRefresh }) => {
    return (
        <div className={styles.header}>
            <div className={styles.titleContainer}>
                <h3 className={styles.title}>Linze IA</h3>
                <img src={images.chatSparkle} alt="Sparkle" className={styles.sparkle} />
            </div>
            <div className={styles.headerActions}>
                {onRefresh && (
                    <button className={styles.refreshButton} onClick={onRefresh} aria-label="Reiniciar chat">
                        <Icon path={mdiRefresh} size={0.8} />
                    </button>
                )}
                <button className={styles.closeButton} onClick={onClose} aria-label="Cerrar chat">
                    <Icon path={mdiClose} size={0.8} />
                </button>
            </div>
        </div>
    );
};

export default ChatHeader;
